<iframe
  #frame
  id="iframe"
  [style.width.px]="containerWidth"
  [style.height.px]="containerHeight"
  [src]="subUrl"
  frameborder="0"
  scrolling="auto"
></iframe>
